import { render } from "./PriceServiceDetailRemark.vue?vue&type=template&id=4548d700&scoped=true&ts=true"
import script from "./PriceServiceDetailRemark.vue?vue&type=script&lang=ts"
export * from "./PriceServiceDetailRemark.vue?vue&type=script&lang=ts"

import "./PriceServiceDetailRemark.vue?vue&type=style&index=0&id=4548d700&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4548d700"]])

export default __exports__